import { isEmptyObject } from "../../../utils/tests";
import { MatchPredictedLineupsQuery } from '../types';

/**
 * typeguard for MatchPredictedLineupsQuery
 * @param MatchPredictedLineupsQuery object passed to transformer
 */
export const isValidMatchPredictedLineups = (obj: MatchPredictedLineupsQuery): boolean => Boolean(obj?.data?.matchPredictedLineup && !isEmptyObject(obj.data.matchPredictedLineup));
